<template>
  <div v-loading="loading" class="content">
    <div class="left">
      <el-page-header
        @back="goBack"
        content="课程卡印制"
      ></el-page-header>
      <el-row style="margin-top: 15px">
        <el-col :span="12">
          <el-button type="primary" size="mini" @click="cardPrintCustomize"
            >课程卡定制</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%; margin-top: 15px"
      >
        <!-- <el-table-column type="index" align="center"></el-table-column> -->
        <el-table-column
          prop="predictName"
          label="名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="printNum"
          label="总卡量"
          align="center"
        ></el-table-column>
        <el-table-column
          label="最后一次操作时间"
          align="center"
          prop="updateTime"
        ></el-table-column>
        <el-table-column
          label="下单人"
          align="center"
          prop="updaterName"
        ></el-table-column>
        <!-- <el-table-column
          label="备注"
          align="center"
          prop="leafName"
        ></el-table-column> -->
        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="scope">
            <el-button type="text" @click="getCardPrintPredict(scope.row)"
            :disabled="scope.row.isOrder==1"
              >修改</el-button
            >
            <el-button
              type="text"
              @click="exportCardPrintPredictDetail(scope.row.id)"
              >导出卡数量</el-button
            >
            <!-- <el-button type="text" :disabled="scope.row.isOrder==1" @click="xiadan(scope.row.id)">下单</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page.sync="pageNum"
        style="margin-top: 15px"
        @prev-click="gai"
        @next-click="gai"
        @current-change="gai"
        background
        layout="total,prev, pager, next"
        :hide-on-single-page="true"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog title="课程卡定制" :visible.sync="dialogVisible" width="800px">
      <div style="margin-bottom: 15px;">
        总卡量：{{printNum}}
      </div>
      <div>
        预估名称：
        <el-input
          style="width: 80%"
          v-model="predictName"
          placeholder="建议填写的时候以学期和月份为名称，如：20-21学年第一学期11月"
        ></el-input>
      </div>
      <el-table
        :data="tableData1"
        border
        stripe
        style="width: 100%; margin-top: 15px"
      >
        <el-table-column type="index" align="center"></el-table-column>
        <el-table-column label="课程类型" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.courseType == 1">国家课程</span>
            <span v-if="scope.row.courseType == 2">校本课程 </span>
            <span v-if="scope.row.courseType == 3">机构课程</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="courseName"
          label="课程名称"
          align="center"
        ></el-table-column>
        <el-table-column label="周课时数" align="center" prop="weekNum">
          <template slot-scope="scope">
            <el-input
              @input="shuru(scope.row)"
              v-model="scope.row.weekNum"
              placeholder="请输入周课时数"
              oninput="value=value.replace(/[^\d]/g,'0')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="每周发放数量"
          align="center"
          prop="weekGrantNum"
        >
          <template slot-scope="scope">
            <el-input
              @input="shuru(scope.row)"
              v-model="scope.row.weekGrantNum"
              placeholder="请输入每周发放数量"
              oninput="value=value.replace(/[^\d]/g,'0')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="周次" align="center" prop="weekFreq">
          <template slot-scope="scope">
            <el-input
              @input="shuru(scope.row)"
              v-model="scope.row.weekFreq"
              placeholder="请输入周次"
              oninput="value=value.replace(/[^\d]/g,'0')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="班级数" align="center" prop="classesNum">
          <template slot-scope="scope">
            <el-input
              @input="shuru(scope.row)"
              v-model="scope.row.classesNum"
              placeholder="请输入班级数"
              oninput="value=value.replace(/[^\d]/g,'0')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="预估数量"
          align="center"
          prop="predictNum"
        >
        </el-table-column>
        <el-table-column
          label="印制数量"
          align="center"
          prop="printNum"
        >
        <template slot-scope="scope">
        <el-input
          @input="wang(scope.row)"
              v-model="scope.row.printNum"
              placeholder="请输入印制数量"
              oninput="value=value.replace(/[^\d]/g,'0')"
            ></el-input>
            </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="saveCardPrintCustomize" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as homeApi from "@/api/observation";
import {
  usercenterinfo
} from '@/api/home'
export default {
  components: {},
  data() {
    return {
      loading: false,
      schoollist: "",
      schoolId: "",
      pageNum: 1,
      total: 0,
      tableData: [],
      dialogVisible: false,
      tableData1: [],
      predictName: "",
      huiid: "",
      printNum:''
    };
  },
  watch: {},
  methods: {
    goBack() {
      this.$emit('backBench','order')
    },
    gai(s) {},
    getSchoolInfo() {
      let that = this;
      let params = {
        id: this.schoolId,
      };
      homeApi
        .getSchoolInfo(params)
        .then((res) => {
          that.schoollist = res.data.data;
        })
        .catch(() => {});
    },
    selectCardPrintPredictList() {
      let that = this;
      let params = {
        schoolId: this.schoolId,
        pageNum: this.pageNum,
        pageSize: 10,
      };
      homeApi
        .selectCardPrintPredictList(params)
        .then((res) => {
          that.tableData = res.data.data.dataList;
          that.total = res.data.data.totalCount;
        })
        .catch(() => {});
    },
    cardPrintCustomize() {
      let that = this;
      this.huiid = "";
      this.predictName = "";
      let params = {
        schoolId: this.schoolId,
      };
      homeApi
        .cardPrintCustomize(params)
        .then((res) => {
          that.dialogVisible = true;
          that.printNum=0
          for(var i=0;i<res.data.data.length;i++){
            that.printNum+=res.data.data[i].printNum
          }
          that.tableData1 = res.data.data;
        })
        .catch(() => {});
    },
    getCardPrintPredict(s) {
      let that = this;
      let params = {
        cardPrintPredictId: s.id,
      };
      homeApi
        .getCardPrintPredict(params)
        .then((res) => {
          that.dialogVisible = true;
          that.huiid = res.data.data.id;
          that.tableData1 = res.data.data.cardPrintPredictDetailList;
          that.printNum = res.data.data.printNum;
          that.predictName = res.data.data.predictName;
        })
        .catch(() => {});
    },
    wang(s){
      let printNum=0
      for (var i = 0; i < this.tableData1.length; i++) {
        printNum+= parseInt(this.tableData1[i].printNum)
      }
      this.printNum=printNum
    },
    shuru(s) {
      let num = 0;
      console.log(s.classesNum);
      s.classesNum = parseInt(s.classesNum == "" ? 0 : s.classesNum);
      s.weekFreq = parseInt(s.weekFreq == "" ? 0 : s.weekFreq);
      s.weekGrantNum = parseInt(s.weekGrantNum == "" ? 0 : s.weekGrantNum);
      //   s.weekNum=parseInt(s.weekNum==''?0:s.weekNum)
      num = s.classesNum * s.weekGrantNum * s.weekFreq;
      let printNum = 0;
      for (var i = 0; i < this.tableData1.length; i++) {
        if (this.tableData1[i].courseName == s.courseName) {
          //   this.$set(this.tableData1[i],'predictNum',num)
          this.tableData1[i].predictNum = num;
          let num1 = num % 500;
          num1 = 500 - num1;
          num1 > 0 ? num1 : 0;
          if(num==0) num1=0
          this.tableData1[i].printNum = num + num1;
          this.$forceUpdate();
        }
        printNum+=parseInt(this.tableData1[i].printNum)
      }
      this.printNum=printNum
    },
    saveCardPrintCustomize() {
      let that = this;
      let predictNum = 0;
      let printNum = 0;
      if (this.predictName == "") {
        that.$message("请输入预估名称");
        return false;
      }
      for (var i = 0; i < this.tableData1.length; i++) {
        if (
          this.tableData1[i].weekNum === "" ||
          this.tableData1[i].classesNum === "" ||
          this.tableData1[i].weekFreq === "" ||
          this.tableData1[i].weekGrantNum === ""
        ) {
          that.$message("请完整数据再提交");
          return false;
        }
        predictNum +=parseInt(this.tableData1[i].predictNum) 
      }
      let params = {
        schoolId: this.schoolId,
        predictName: this.predictName,
        cardPrintPredictDetailList: this.tableData1,
        schoolName: this.schoollist.name,
        predictNum: predictNum,
        printNum:this. printNum,
        id: this.huiid,
      };
      homeApi
        .saveCardPrintCustomize(params)
        .then((res) => {
          that.dialogVisible = false;
          that.selectCardPrintPredictList();
        })
        .catch(() => {});
    },
    exportCardPrintPredictDetail(s) {
      let that = this;
      var url = homeApi.exportCardPrintPredictDetail;
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url + "?cardPrintPredictId=" + s);
      xhr.setRequestHeader("token", localStorage.getItem("token"));
      xhr.responseType = "blob"; // 设置返回类型blob
      xhr.onload = function () {
        //   if ( this.status === 201) {//this.status === 200 ||
        if (this.status === 200 || this.status === 201) {
          var blob = this.response;
          var reader = new FileReader();
          reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href

          reader.onload = function (e) {
            // 转换完成后创建a标签下载
            var a = document.createElement("a");
            a.download = "卡数量.xlsx";
            a.href = e.target.result;
            a.click();
          };
          that.loading = false;
          that.$message({
            message: "导出成功",
            type: "success",
          });
        } else {
          that.$message("导出失败");
          that.loading = false;
        }
      };
      xhr.send();
    },
    xiadan(s){
        localStorage.setItem("xdid",s);
        this.$emit("navlink", 'bazaar_place');
    },
  },
  async mounted() {
    const { data: res } = await usercenterinfo()
    this.schoolId = res.data.schoolId
    this.getSchoolInfo();
    this.selectCardPrintPredictList();
  },
};
</script>

<style lang='less' scoped>
.content{
    box-sizing: border-box;
    padding:10px;
    height: 100%;
    background:#fff;
}
</style>


// WEBPACK FOOTER //
// src/views/bench/components/cardCustomization.vue